import getUserConfiguration from '../actions/getUserConfiguration';

export default function getDefaultOnlineMeetingEnabled(): boolean {
    const userConfig = getUserConfiguration();

    return userConfig ? !!userConfig.UserOptions?.AddOnlineMeetingToAllEvents : false;
}
